import { UPDATE_USER_INFO_SUCCESS } from '@/constants';

import * as constants from './Setting.constants';
import * as services from './Setting.service';

const state = {
  isRequest: false,
  //
  qrcodeStatus: -100,
};

const mutations = {
  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },

  [constants.SET_QRCODE_STATUS](state, data) {
    state.qrcodeStatus = data.data;
  },

  [constants.DUMMY_MUTATION]() { },
};

const actions = {
  async updateNicknameGender({ commit }, payload) {
    const res = await services.updateNicknameGender(payload);
    if (res.data.data) {
      commit(UPDATE_USER_INFO_SUCCESS, payload, { root: true });
    }
    return res;
  },

  async updateavatar({ commit }, payload) {
    const res = await services.updateavatar(payload.formData);
    if (res.data.data) {
      commit(UPDATE_USER_INFO_SUCCESS, { avatar: payload.avatar }, { root: true });
    }
    return res;
  },

  async updatePassword({ commit }, payload) {
    const res = await services.updatePassword(payload);
    if (res.data.data) {
      commit(constants.DUMMY_MUTATION, payload);
    }
    return res;
  },

  async checkMobile({ commit }, payload) {
    const res = await services.checkMobile(payload);
    if (res.data.data) {
      commit(constants.DUMMY_MUTATION, payload);
    }
    return res;
  },

  async editPassword({ commit, dispatch }, payload) {
    const res = await services.editPassword(payload);
    if (200 === res.data.status) {
      commit(constants.DUMMY_MUTATION, payload);
      dispatch('getUserInfo', null, { root: true });
    }
    return res;
  },

  async bindEmail({ commit }, payload) {
    const res = await services.bindEmail(payload);
    if (res.data.data) {
      commit(
        UPDATE_USER_INFO_SUCCESS,
        {
          email: payload.email,
          hasBindEmail: true,
        },
        { root: true }
      );
    }
    return res;
  },

  async updatWechat({ commit }, payload) {
    const res = await services.updatWechat(payload);
    if (res.data.data) {
      commit(UPDATE_USER_INFO_SUCCESS, { wechat: payload.weChatNo }, { root: true });
    }
    return res;
  },

  async unbindWechat({ commit }) {
    await services.unbindWechat();
    commit(constants.DUMMY_MUTATION);
  },

  async checkBindQrcode({ commit, dispatch }, payload) {
    const res = await services.checkBindQrcode(payload);
    commit(constants.SET_QRCODE_STATUS, res.data);
    if (1 === res.data.data) {
      /* commit(
        UPDATE_USER_INFO_SUCCESS,
        {
          hasBindWechat: true,
        },
        { root: true }
      ); */
      dispatch('getUserInfo', null, { root: true });
    }
    return res;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
